export enum ResultsType {
    products = 'products',
    workers = 'workers',
    merchants = 'merchants',
    services = 'services',
    orders = 'orders',
    reservations = 'reservations',
    promotions = 'promotions',
    pointsServices = 'pointsServices',
}
